import StripesRockSvg from "../components/RadioChannelsList/assets/StripesRockSvg";
import StripesMCSvg from "../components/RadioChannelsList/assets/StripesMCSvg";
import StripesLiteSvg from "../components/RadioChannelsList/assets/StripesLiteSvg";
import TitleRockSvg from "../components/RadioChannelsList/assets/TitleRockSvg";
import TitleMcSvg from "../components/RadioChannelsList/assets/TitleMcSvg";
import TitleLiteSvg from "../components/RadioChannelsList/assets/TitleLiteSvg";

export const channelsList = [
  {
    type: "rock",
    title: <TitleRockSvg />,
    img: "/guitar.png",
    stripes: <StripesRockSvg />,
    duration: 500,
  },
  {
    type: "mc",
    title: <TitleMcSvg />,
    img: "/microphones.png",
    stripes: <StripesMCSvg />,
    duration: 1100,
  },
  {
    type: "lite",
    title: <TitleLiteSvg />,
    img: "/plate.png",
    stripes: <StripesLiteSvg />,
    duration: 1600,
  },
];
